import IconButton from '../../../../../../../common/IconButton/IconButton'
import Input, {Size} from '../../../../../components/Input'

import type {PipelineParameterFormFieldsetProps} from './PipelineParameterFormFieldset.types'
import usePipelineParameterFormFieldset from './usePipelineParameterFormFieldset'

import styles from './PipelineParameterFormFieldset.css'

function PipelineParameterFormFieldset({
  value = '',
  name = '',
  parameterNames = [],
  onKeyPress,
  onValid,
  onChange,
  onDelete,
}: PipelineParameterFormFieldsetProps) {
  const {
    parameterNameErrorMessage,
    parameterValueErrorMessage,
    parameterNameChangeInputHandler,
    parameterValueChangeInputHandler,
  } = usePipelineParameterFormFieldset(name, value, parameterNames, onChange, onValid)

  return (
    <div className={styles.pipelineParameterWrapForm}>
      <div className={styles.pipelineParameterFormInput}>
        <Input
          placeholder={'Parameter Name'}
          onChange={parameterNameChangeInputHandler}
          onKeyPress={onKeyPress}
          value={name}
          size={Size.FULL}
          aria-label="Parameter Name"
          type="text"
          error={parameterNameErrorMessage}
          autoComplete="off"
        />
      </div>
      <div>{'='}</div>
      <div className={styles.pipelineParameterFormInput}>
        <Input
          placeholder={'Value'}
          onChange={parameterValueChangeInputHandler}
          onKeyPress={onKeyPress}
          value={value}
          size={Size.FULL}
          aria-label="Value"
          error={parameterValueErrorMessage}
          autoComplete="off"
        />
      </div>
      {onDelete && (
        <IconButton
          className={styles.deleteButton}
          icon={'trash'}
          title={'Delete'}
          aria-label={'Delete'}
          onClick={onDelete}
        />
      )}
    </div>
  )
}

export default PipelineParameterFormFieldset
